export default __webpack_public_path__ + "static/media/G0065.34I-39578_-23527_0.ee4e9bed.jpg";